module.exports = __webpack_public_path__ + "static/media/0027_IMG_LE_SOL_MEGALITH_MEGABROWN.a5a367f9.png";